import { DatePipe } from "@angular/common";
import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { LabelComponent } from "@components/label/label.component";
import { ToastService } from "@components/toast/toast.service";
import { BusyService } from "~app/common/components/busy/busy.service";
import { VKDirektutbyte } from "~app/features/virkeskop/models/tradslag/direktutbyte-models";
import { AtgardMediatorService } from "~app/features/virkeskop/services/atgard-mediator.service";
import { AvtalService } from "~app/features/virkeskop/services/avtal.service";
import { TradslagMediatorService } from "~app/features/virkeskop/services/tradslag-mediator.service";

@Component({
    selector: "rask-forkalkyl-arboreal",
    templateUrl: "./forkalkyl-arboreal.component.html",
    styleUrls: ["./forkalkyl-arboreal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ButtonComponent,
        LabelComponent,
        DatePipe
    ]
})
export class ForkalkylArborealComponent {
    protected model: VKDirektutbyte;

    private readonly atgardMediatorService = inject(AtgardMediatorService);
    private readonly avtalService = inject(AvtalService);
    private readonly busyService = inject(BusyService);
    private readonly toast = inject(ToastService);
    private readonly tradslagMediatorService = inject(TradslagMediatorService);

    protected getArboreal(): VKDirektutbyte {
        const atgard = this.atgardMediatorService.atgard;

        this.busyService.addWork(this.avtalService.getArboreal(atgard.id))
            .subscribe({
                next: tradslag => {
                    if (tradslag.errorMessage) {
                        this.toast.add(tradslag.errorMessage, tradslag.messageLevel);
                        return;
                    }
                    this.tradslagMediatorService.mapDirektutbyteFromArboreal(tradslag, atgard.guid);
                },
                error: () => {
                //
                }
            });

        return this.tradslagMediatorService.direktutbyte;
    }
}
